import {APP_VERSION} from "./version";

export class AirlineAppPublicObject {
    get version(): string {
        return APP_VERSION;
    }
}
